import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketClientUserInteractionsService {

    constructor(){

        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.TICKET_CLIENT_USER_INTERACTIONS = '/api/ticket-client-user-interactions';
        this.GET_LIST_BY_ITEM = '/list/itemId/{itemId}';
        this.GET_LIST_BY_ITEM_AND_LINK = '/list/itemId/{itemId}/linkType/{linkType}/linkId/{linkId}';

    }

    async getListByItemId(itemId) {
        try {
            let url = window.location.origin + this.TICKET_CLIENT_USER_INTERACTIONS + this.GET_LIST_BY_ITEM;
            url = url
                .replace('{itemId}',itemId)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByItemIdAndLinkTypeAndLinkId(itemId, linkType, linkId) {
        try {
            let url = window.location.origin + this.TICKET_CLIENT_USER_INTERACTIONS + this.GET_LIST_BY_ITEM_AND_LINK;
            url = url
                .replace('{itemId}',itemId)
                .replace('{linkType}', linkType)
                .replace('{linkId}', linkId)
            const dateRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return dateRet;
        } catch (err) {
            console.log(err);
        }
    }

}

export default TicketClientUserInteractionsService;
